import { Navigate, useLocation } from "react-router-dom";

export default function Login() {
  const location = useLocation();
  const from = location.state?.from?.pathname;
  const dest = from ? `/?redirect=${encodeURIComponent(from)}` : "/";
  return <Navigate to={dest} replace />;
}
